import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  MarketDrawerRootReducerState,
  getMarketsSelectedState,
  getMarketsLoadingState
} from '../../../../state/reducer';
import { MarketView } from '../../../../models/markets';

@Component({
  selector: 'muni-gameday-market-drawer-markets-header',
  templateUrl: './markets-header.template.html',
  styleUrls: ['./markets-header.styles.scss']
})
export class MarketsHeaderComponent {
  public readonly selected: Observable<MarketView> = this.store.pipe(
    select(getMarketsSelectedState),
    distinctUntilChanged()
  );
  public readonly loading: Observable<boolean> = this.store.pipe(
    select(getMarketsLoadingState),
    distinctUntilChanged()
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}
}
